export default __webpack_public_path__ + "static/media/open-padlock.adb080ec.svg";